import { memo } from "react";
import { createPortal } from "react-dom";
import styles from "./BaseModal.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type BaseModalProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width?: string;
  maxWidth?: string;
  closeOnOverlay?: boolean;
};

const BaseModal = (props: BaseModalProps) => {
  const { open, onClose, children, width, maxWidth, closeOnOverlay = true } = props;

  if (!open) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (closeOnOverlay && e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  const modalContent = (
    <div className={cx("base-modal-overlay")} onClick={handleOverlayClick}>
      <div
        className={cx("base-modal-container")}
        style={{ width: width, maxWidth: maxWidth }}
        onClick={handleContainerClick}
      >
        {children}
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default memo(BaseModal);
